import React, { useState } from "react";
import { Star } from "lucide-react";
import { Dropdown, DropdownToggle, DropdownMenu } from "@/design-system/native";
import styles from "./BookmarkHeader.module.scss";
const BookmarkHeader = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prev) => !prev);

  return (
    <li className={`${styles.item} header-svg-icon`}>
      <Dropdown isOpen={open} toggle={toggle} direction="down">
        <DropdownToggle tag="div" className={styles.toggle}>
          <Star size={21} stroke="#404040e6" color="#404040e6" />
        </DropdownToggle>

        <DropdownMenu
          className={styles.menu}
          modifiers={[
            { name: "offset", options: { offset: [0, 6] } },
            {
              name: "preventOverflow",
              options: { boundary: "viewport", padding: 8 },
            },
          ]}
        >
          To access your favorite clients quickly, please go to the client view
          and mark the star.
        </DropdownMenu>
      </Dropdown>
    </li>
  );
};

export default BookmarkHeader;
